import explainList from '../../application/staticData/info/CREDIT_SCORE';
import { HOME_BANNER as simpleList } from '../../application/staticData/Banner/HOME_BANNER';

import {
  FlexBox,
  RecordBox,
  DefaultBox,
  SideBox,
  BannerBox,
  TimerBox,
} from '../etc/LBox/LBox';

import {
  Skeleton,
  HeadTitle,
  ItemContent,
  Button,
  SimpleItem,
  SegmentButtons,
  GraphItem,
  Explain,
  ExplainItem,
  Divider,
  TheFooter,
  SpacerSection,
  Spacer,
  Tsmbd22,
  Popup,
  BridgeModal,
} from 'oui';

import useResultEntry from '../../application/bloc/useResultEntry';
import useFooter from '../../application/hooks/useFooter';
import useBlocker from '../../application/hooks/useBlocker';

import moment from 'moment/moment';
import { addUnitToMaxAmount } from '../../application/helper/filter';
import { Timer } from '../../application/helper/resultExpireTimer';
import EmptyResult from '../etc/EmptyResult/EmptyResult';
import Rolling from '../component/Rolling/Rolling';

const ResultEntry = () => {
  const {
    media,
    navigateBannerToPage,
    navigateCurrentProductItem,
    navigateResult,
    todayLoanInfo,
    toDayRemainTime,
    sortingItems,
    changeSort,
    sort,
    height,
    hasCurrentProductItem,
    hasTodayLoanInfo,
    showAlert,
    setShowAlert,
    alertContent,
    onClickNaviButton,
    sendBeaconClkBtnDetailList,
    sendBeaconClkBtnRateRecord,
    sendBeaconClkBtnLimitRecord,
    sendBeaconClkBtnNotiSchAlrt,
    sendBeaconClkBtnIntrstCalc,
    sendBeaconClkBtnLoanPrdRecentHit,
    sendBeaconClkBtnEbmpOutlink,
    isLoading,
    navigateDA,
    isBridgeModal,

    bannerList,
    hasBannerList,
    isRedirect,
  } = useResultEntry();

  const { navigateOvertake, navigateOvertakePrivacy, navigateTestPage } =
    useFooter();
  useBlocker((tx: any) => {
    if (tx.action === 'POP' && !hasTodayLoanInfo) {
      setShowAlert(true);
      return;
    } else {
      tx.retry();
    }
  }, true);

  const getPreReqTime =
    moment(
      todayLoanInfo?.preRequestInfoData?.regDate,
      'YYYY.MM.DD HH:mm:ss',
    ).format('YYYY.MM.DD HH:mm') !== 'Invalid date'
      ? moment(
          todayLoanInfo?.preRequestInfoData?.regDate,
          'YYYY.MM.DD HH:mm:ss',
        ).format('YYYY.MM.DD HH:mm')
      : '0000.00.00 00:00';

  const getHeight = (args: any) => {
    let min = Math.min(...args);
    let max = Math.max(...args);
    return args.map((arg: any) => {
      if (min === max) return 20;
      return Math.floor(((arg - min) * 63) / (max - min) + 20);
    });
  };

  const handleClickBanner = (idx: number) => {
    // if (idx === 0) {
    //   sendBeaconClkBtnNotiSchAlrt('정기 알림');
    // } else if (idx === 1) {
    sendBeaconClkBtnIntrstCalc('이자계산기');
    // }
    navigateBannerToPage(1);
  };
  const handleClickProduct = () => {
    sendBeaconClkBtnLoanPrdRecentHit('조회 중인 대출 상품');
    navigateCurrentProductItem();
  };
  const handleClickNoResultBtn = () => {
    sendBeaconClkBtnEbmpOutlink('다른 대출 상품 보기');
    onClickNaviButton();
  };
  const handleClickTab = (e: any, data: { index: number }) => {
    if (data?.index === 0) {
      sendBeaconClkBtnRateRecord('금리');
    } else if (data?.index === 1) {
      sendBeaconClkBtnLimitRecord('한도');
    }
    changeSort(data?.index);
  };
  const handleClickCta = (e: any) => {
    sendBeaconClkBtnDetailList(e.target.innerHTML);
    navigateResult();
  };

  if (isRedirect) return null;

  return (
    <>
      {!hasTodayLoanInfo ? (
        <EmptyResult
          getPreReqTime={getPreReqTime}
          onClickMainBtn={handleClickNoResultBtn}
        />
      ) : (
        <>
          {isLoading ? (
            <Skeleton type={'d'} />
          ) : (
            <>
              <DefaultBox>
                <Tsmbd22 text={'나의 조회 결과'} />
                {toDayRemainTime && (
                  <TimerBox>
                    <p>유효시간</p>
                    <Timer
                      hour={toDayRemainTime[0] ?? 0}
                      minute={toDayRemainTime[1] ?? 0}
                      second={toDayRemainTime[2] ?? 0}
                    />
                  </TimerBox>
                )}
              </DefaultBox>
              <SideBox>
                <FlexBox>
                  <ItemContent
                    textTitle={`${todayLoanInfo?.minInterest ?? ''}%`}
                    subTitle={'최저 금리'}
                    stress={true}
                  />
                  <div style={{ width: '32px' }} />
                  <ItemContent
                    textTitle={addUnitToMaxAmount(
                      todayLoanInfo?.maxAmount ?? '',
                    )}
                    subTitle={'최대 한도'}
                    stress={true}
                  />
                </FlexBox>
                <Spacer size={'md'} />
                <Button
                  configuration={'contained'}
                  flexible={true}
                  onClick={handleClickCta}
                >
                  더 많은 상품 보기
                </Button>
              </SideBox>
              <Spacer size={'xs'} />
            </>
          )}

          {hasBannerList && (
            <BannerBox>
              <Rolling
                items={bannerList}
                onClickItem={(idx) => {
                  bannerList[idx].navigate();
                  bannerList[idx].beacon.click();
                }}
                onChangeItem={(idx) => {
                  bannerList[idx].beacon.view();
                }}
              />
            </BannerBox>
          )}

          {hasCurrentProductItem && (
            <>
              <HeadTitle textTitle={'조회 중인 대출 상품'} />
              <SideBox>
                <SimpleItem
                  state={'enabled'}
                  avatar={{
                    source:
                      todayLoanInfo?.currentProductItem?.logoImgUrl ?? 'logo',
                    alt: todayLoanInfo?.currentProductItem?.companyNm ?? 'logo',
                    size: 'md',
                  }}
                  headerText={
                    todayLoanInfo?.currentProductItem?.companyNm ?? 'companyNm'
                  }
                  subheaderText={
                    todayLoanInfo?.currentProductItem?.productNm ?? 'productNm'
                  }
                  stress={false}
                  onClickSimpleItem={handleClickProduct}
                />
                <Spacer size={'md'} />
              </SideBox>
            </>
          )}

          <Divider type={'contents'} />

          <HeadTitle
            textTitle={'최근 조회 기록'}
            subTitle={'3개월 이후 조회 기록은 삭제되고 있어요'}
          />
          <DefaultBox>
            <SegmentButtons
              items={sortingItems}
              activeIdx={sortingItems.findIndex((item) => item.value === sort)}
              varient={'b'}
              onClickButton={handleClickTab}
            />
          </DefaultBox>
          <RecordBox>
            {todayLoanInfo?.preRequestHistInfoList?.map(
              (item: any, i: number) => {
                return (
                  <GraphItem
                    key={i}
                    color={
                      i === todayLoanInfo?.preRequestHistInfoList.length - 1
                        ? 'primary'
                        : 'default'
                    }
                    height={
                      getHeight(height?.map((item: any) => item[sort]))[i]
                    }
                    date={item.date}
                    value={item[sort]}
                  />
                );
              },
            )}
          </RecordBox>
          <DefaultBox>
            <Explain
              title={'신용점수를 올리면 많은 상품을 볼 수 있어요'}
              children={explainList.map((item: any) => {
                return (
                  <ExplainItem
                    key={item.title}
                    title={item.title}
                    subTitle={item.subTitle}
                    avatar={{
                      source: item.source,
                      alt: item.alt,
                    }}
                  />
                );
              })}
            />
          </DefaultBox>

          <Divider type={'contents'} />
          <SideBox>
            <SpacerSection
              size={'sm'}
              children={
                <>
                  {simpleList.map((item: any, idx) => {
                    return (
                      <>
                        {idx > 0 && <Spacer size={'sm'} />}
                        <SimpleItem
                          key={idx + item.subheaderText + idx}
                          state={item.avatar.state}
                          avatar={item.avatar}
                          headerText={item.headerText}
                          subheaderText={item.subheaderText}
                          stress={false}
                          onClickSimpleItem={() => handleClickBanner(idx)}
                        />
                      </>
                    );
                  })}
                </>
              }
            />
          </SideBox>
          <TheFooter
            type={'a'}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
            onClickTest={navigateTestPage}
          />
        </>
      )}

      <Popup
        title={alertContent.message}
        isPopupOpen={showAlert}
        confirmBtn={{
          text: alertContent.confirmText,
          onClick: alertContent.handleClickConfirm,
        }}
        cancelBtn={
          alertContent.cancelText && alertContent.handleClickCancel
            ? {
                text: alertContent.cancelText,
                onClick: alertContent.handleClickCancel,
              }
            : undefined
        }
      />

      <BridgeModal
        isBridgeModalOpen={isBridgeModal}
        message={'대출비교서비스에서 금융상품으로\n 이동 중이에요'}
        onDone={() => {
          navigateDA(media);
        }}
        timeout={2000}
      />
    </>
  );
};

export default ResultEntry;
